import d from "moment";
import { b as I } from "../_baseIteratee-4c4d0995.mjs";
import { s as g, S as b, c as w } from "../_baseIsEqual-12d01a44.mjs";
import { S as m } from "../_getTag-4e44633b.mjs";
import { n as a } from "../noop-378485d5.mjs";
import O from "./getListOutletOpeningHoursTable.mjs";
import "../identity-6eafe87b.mjs";
import "../isArray-0d9c7aaa.mjs";
import "../toString-3b91b335.mjs";
import "@ancon/wildcat-types";
import "../shared/isWithinFlag.mjs";
import "../shared/generateId.mjs";
import "react";
import "../time/getTimeSpanParts.mjs";
import "../date/createLocalTimezoneMoment.mjs";
import "../date/convertToLocalTimezone.mjs";
import "../date/getTimezoneUtcOffsetDifference.mjs";
function S(n, t, e, i) {
  for (var o = n.length, r = e + (i ? 1 : -1); i ? r-- : ++r < o; )
    if (t(n[r], r, n))
      return r;
  return -1;
}
function T(n) {
  return n !== n;
}
function x(n, t, e) {
  for (var i = e - 1, o = n.length; ++i < o; )
    if (n[i] === t)
      return i;
  return -1;
}
function A(n, t, e) {
  return t === t ? x(n, t, e) : S(n, T, e);
}
function H(n, t) {
  var e = n == null ? 0 : n.length;
  return !!e && A(n, t, 0) > -1;
}
function N(n, t, e) {
  for (var i = -1, o = n == null ? 0 : n.length; ++i < o; )
    if (e(t, n[i]))
      return !0;
  return !1;
}
var W = 1 / 0, k = m && 1 / g(new m([, -0]))[1] == W ? function(n) {
  return new m(n);
} : a;
const $ = k;
var q = 200;
function C(n, t, e) {
  var i = -1, o = H, r = n.length, h = !0, u = [], s = u;
  if (e)
    h = !1, o = N;
  else if (r >= q) {
    var p = t ? null : $(n);
    if (p)
      return g(p);
    h = !1, o = w, s = new b();
  } else
    s = t ? [] : u;
  n:
    for (; ++i < r; ) {
      var f = n[i], l = t ? t(f) : f;
      if (f = e || f !== 0 ? f : 0, h && l === l) {
        for (var c = s.length; c--; )
          if (s[c] === l)
            continue n;
        t && s.push(l), u.push(f);
      } else
        o(s, l, e) || (s !== u && s.push(l), u.push(f));
    }
  return u;
}
function E(n, t) {
  return n && n.length ? C(n, I(t)) : [];
}
function P(n) {
  const t = O(n), i = d().isoWeekday(), o = t.reduce(
    (r, { openingHours: h }) => {
      var s;
      const u = (s = h.find(
        (p) => p.isoWeekday === i
      )) == null ? void 0 : s.open;
      return u && r.push(...u), r;
    },
    []
  );
  return o ? E(o, (r) => `${r.start}-${r.end}`) : null;
}
export {
  P as default
};
